const buryConfig = [

  {
    name: '',
    key: '',
    modules: [
      {
        name: 'header',
        eventList: [
          {
            name: '搜索',
            key: 'search'
          },
          {
            name: '语言',
            key: 'language'
          }
        ]
      }
    ]
  },
  {
    name: '首页',
    key: 'home_page',
    modules: [
      {
        name: '',
        eventList: [
          {
            name: '首页访问',
            key: 'home_page_sw'
          },
          {
            name: '首页',
            key: 'home_page__button'
          },
          {
            name: '立即联系',
            key: 'home_page_Contact_button'
          }
        ]
      }
    ]
  },
  {
    name: '广告资讯页',
    key: 'Advertising_Information_Page',
    modules: [
      {
        name: '广告合作',
        eventList: [
          {
            name: '立即提交',
            key: 'Advertisement_page_submit_button'
          }
        ]
      }
    ]
  },
  {
    name: '合作案例页',
    key: 'Case_page',
    modules: []
  },
  {
    name: '天气资讯页',
    key: 'Weather_Information_Page',
    modules: []
  },
  {
    name: '天气预报页',
    key: 'Weather_Forecast_Page',
    modules: []
  },
  {
    name: '墨迹天气APP页',
    key: 'Weather_APP_page',
    modules: [
      {
        name: 'banner',
        eventList: [
          {
            name: 'App Store下载',
            key: 'Weather_APP_page_banner_Download_iOS'
          },
          {
            name: 'Android下载',
            key: 'Weather_APP_page_banner_Download_Android'
          }
        ]
      },
      {
        name: '下载渠道',
        eventList: [
          {
            name: 'iOS版下载',
            key: 'Weather_APP_page_channel_Download_iOS'
          },
          {
            name: 'Android版下载',
            key: 'Weather_APP_page_channel_Download_Android'
          },
          {
            name: '其他渠道下载',
            key: 'Weather_APP_page_channel_Download_else'
          }
        ]
      }
    ]
  },
  {
    name: '墨迹天气会员页',
    key: 'Member_Page',
    modules: [
      {
        name: 'banner',
        eventList: [
          {
            name: '下载APP体验VIP',
            key: 'Member_Page_banner_Download'
          }
        ]
      },
      {
        name: '下载渠道',
        eventList: [
          {
            name: 'iOS版下载',
            key: 'Member_Page_channel_Download_iOS'
          },
          {
            name: 'Android版下载',
            key: 'Member_Page_channel_Download_Android'
          },
          {
            name: '其他渠道下载',
            key: 'Member_Page_channel_Download_else'
          }
        ]
      }
    ]
  },
  {
    name: 'MojiWeather APP页',
    key: 'MojiWeather_APP_page',
    modules: [
      {
        name: '下载渠道',
        eventList: [
          {
            name: 'iOS版下载',
            key: 'MojiWeather_APP_page_Download_iOS'
          },
          {
            name: 'Android版下载',
            key: 'MojiWeather_APP_page_Download_Android'
          },
          {
            name: '其他渠道下载',
            key: 'MojiWeather_APP_page_Download_else'
          }
        ]
      }
    ]
  },
  {
    name: 'MojiWeather 会员页',
    key: 'MojiWeather_Member_Page',
    modules: [
      {
        name: 'banner',
        eventList: [
          {
            name: 'App Store下载',
            key: 'MojiWeather_Member_Page_banner_Download_iOS'
          },
          {
            name: 'Google Play下载',
            key: 'MojiWeather_Member_Page_banner_Download_Android'
          }
        ]
      },
      {
        name: '下载渠道',
        eventList: [
          {
            name: 'iOS版下载',
            key: 'MojiWeather_Member_Page_channel_Download_iOS'
          },
          {
            name: 'Android版下载',
            key: 'MojiWeather_Member_Page_channel_Download_Android'
          },
          {
            name: '其他渠道下载',
            key: 'MojiWeather_Member_Page_channel_Download_else'
          },
        ]
      }
    ]
  },
  {
    name: '人才招募页',
    key: 'Recruitment_Page',
    modules: [
      {
        name: '招聘岗位',
        eventList: [
          {
            name: '投递简历',
            key: 'Recruitment_Page_resume_button'
          }
        ]
      }
    ]
  },
  {
    name: '新闻资讯页',
    key: 'news_page',
    modules: []
  },
  {
    name: '品牌故事页',
    key: 'Story_Page',
    modules: []
  },
  {
    name: '企业介绍页',
    key: 'Introduction_Page',
    modules: [
      {
        name: '视频',
        eventList: [
          {
            name: '播放',
            key: 'Introduction_Page_play_button'
          },
          {
            name: '暂停',
            key: 'Introduction_Page_pause_button'
          }
        ]
      }
    ]
  },
  {
    name: '墨迹之路页',
    key: 'History_Page',
    modules: []
  },
  {
    name: '联系我们页',
    key: 'Contact_Page',
    modules: []
  }
]

function isMobileDevice() {
  const userAgent = navigator.userAgent.toLowerCase()
  return /android|iphone|ipad|ipod|blackberry|mini|mobi|tablet/.test(userAgent)
}

export const findBuryKey = (key: string) => {
  buryConfig.forEach((page) => {
    page.modules.forEach((module) => {
      module.eventList.forEach((event) => {
        if (event.key === key) {
          sendBuryClient({
            key: event.key,
            name: event.name,
            page: page.name || '',
            module: module.name || '',
          })
        }
      })
    })
  })
}

export const sendBuryClient = (buryInfo: any) => {
  const platform = isMobileDevice()
  window._bury?.track(buryInfo.key, {
    activity_name: 'mojiwww',
    platform: platform ? 'h5' : 'web',
    pageName: buryInfo.name || '',
    module: buryInfo.module || ''
  })
}
